import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { AppRoutes } from './routes.tsx';
import "../src/assets/css/custom.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";
import { ThemeProvider } from "./ThemeContext/ThemeContext.tsx"; 
import { MGTProviderSetup } from "./Auth/MGTProviderSetup.tsx";
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { RequestTypeProvider } from './Context/RequestTypeContext.tsx';
import { PermissionProvider } from './Context/PermissionContext.tsx';

export default function App() {
  const { instance } = useMsal();

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "msal-logout") {
        // Logout was triggered in another tab
        instance.logout(); // Or logoutRedirect/logoutPopup depending on your use
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [instance]);

  return (
    <ThemeProvider>
      <RequestTypeProvider>
      <PermissionProvider>
      <div className="">
        <MGTProviderSetup />
        <Router>
          <AppRoutes />
        </Router>
      </div>
      </PermissionProvider>
      </RequestTypeProvider>
    </ThemeProvider>
  );
}